export default "__VITE_ASSET__2c7ab937__"